import { render, staticRenderFns } from "./AsEmployeeVideoCheckpointInstructions.vue?vue&type=template&id=52b67528&scoped=true"
import script from "./AsEmployeeVideoCheckpointInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./AsEmployeeVideoCheckpointInstructions.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsEmployeeVideoCheckpointInstructions.vue?vue&type=style&index=0&id=52b67528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b67528",
  null
  
)

export default component.exports